/* 30 Oct 2026 (Claude): product card photo arrows + Artwork / Interior switch (Tony, after GoodMood).
   - Mouse devices: hovering a card shows a round arrow on the photo; clicking steps through the print's photos (wraps),
     a back arrow appears once you have moved. Replaces the old hover swap to the second photo.
   - Collection pages: "Artwork | Interior" switch. Interior shows each card's room photo (the same room-aware photo the
     hover used), remembered for the visit. Desktop/tablet only (phones swipe to the room photo already).
   - Phones (30 Oct, GoodMood-style): a sticky bar on collection pages - filter button, Artwork | Interior pill (Interior
     swipes each card to its room photo), and a details button that shows/hides the card bullet points (Shop view).
   - Every arrow click is pushed to the dataLayer as event "laboo_card_photo" (product, photo number, direction),
     so GTM can send it to GA4. */
(function () {
  var KEY = 'laboo_card_view';
  // 1 Nov 2026: rounded arrows (filled), GoodMood style
  var CHEV = { next: 'M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41l-6.58-6.6a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1',
    prev: 'M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42a.9959.9959 0 0 0-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1' };

  function path(u) { try { return new URL(u, location.href).pathname; } catch (e) { return u || ''; } }
  // Interior only applies where the switch is shown (collection pages), so other pages always show the artwork
  function getView() {
    var sw = [].slice.call(document.querySelectorAll('.lb-art-toggle, .lb-mbar')).filter(function (x) { return getComputedStyle(x).display !== 'none'; })[0];
    if (!sw) return 'artwork';  // no switch here (other pages)
    try { return sessionStorage.getItem(KEY) === 'interior' ? 'interior' : 'artwork'; } catch (e) { return 'artwork'; }
  }
  function saveView(v) { try { sessionStorage.setItem(KEY, v); } catch (e) {} }

  function list(card) {
    if (!card.__lbImgs) card.__lbImgs = (card.getAttribute('data-lb-imgs') || '').split('|').filter(Boolean);
    return card.__lbImgs;
  }
  // index of the card's room photo: the hover photo picked server-side, else the second photo
  function roomIndex(card) {
    var imgs = list(card), sec = card.querySelector('.product-item__image .second-img');
    if (sec) {
      var p = path(sec.getAttribute('src') || '');
      for (var i = 1; i < imgs.length; i++) if (path(imgs[i]) === p) return i;
    }
    return imgs.length > 1 ? 1 : 0;
  }
  function figure(card) {
    return card.querySelector('a.product-item__image .product-item__image-figure--top') || card.querySelector('a.product-item__image figure')
      || card.querySelector('a.lpah-card__link, .lpah-wall__media');  // 2 Nov 2026: product-page row cards
  }

  function show(card, idx) {
    var imgs = list(card), fig = figure(card);
    if (!fig || !imgs.length) return;
    card.__lbIdx = idx;
    var alt = fig.querySelector('.lb-card-alt');
    if (idx === 0) { if (alt) alt.remove(); }
    else {
      if (!alt) {
        alt = document.createElement('img');
        alt.className = 'lb-card-alt';
        alt.alt = '';
        alt.decoding = 'async';
        fig.appendChild(alt);
      }
      // keep the current photo until the next one has loaded (no blank flash)
      var want = imgs[idx], pre = new Image();
      card.__lbWant = want;
      pre.onload = pre.onerror = function () { if (card.__lbWant === want) alt.src = want; };
      pre.src = want;
      if (!alt.getAttribute('src')) alt.src = want;
    }
    preload(card, idx + 1);
    var prev = card.querySelector('.lb-card-nav--prev');
    if (prev) prev.hidden = idx === 0;
  }

  // fetch the photo the next arrow click will show, so it appears at once
  function preload(card, i) {
    var imgs = list(card);
    if (imgs.length < 2) return;
    i = i % imgs.length;
    card.__lbPre = card.__lbPre || {};
    if (i === 0 || card.__lbPre[i]) return;
    card.__lbPre[i] = 1;
    new Image().src = imgs[i];
  }

  // phones: swipe the card's photo carousel to the room photo (slide 2) or back to the artwork, without animation.
  // Reads only (no writes), so a whole page of cards is measured in one layout pass (Tony 30 Oct: the tap took ~2 s
  // because each card's write forced a fresh layout of the page before the next card was read).
  function phoneTarget(card, v) {
    var track = card.querySelector('[data-laboo-card-carousel-track]');
    if (!track || !track.offsetParent) return null;
    var slides = track.querySelectorAll('[data-laboo-card-carousel-slide]');
    if (slides.length < 2) return null;
    var target = v === 'interior' ? slides[1] : slides[0];
    return { track: track, img: target.querySelector('img'), left: target.offsetLeft - slides[0].offsetLeft };
  }
  function phoneGo(jobs) {
    jobs.forEach(function (j) {
      if (j.img && j.img.loading === 'lazy') j.img.loading = 'eager';
      j.track.scrollTo({ left: j.left, behavior: 'instant' });
    });
  }
  function isPhone() {
    var bar = document.querySelector('.lb-mbar');
    return !!bar && getComputedStyle(bar).display !== 'none';
  }

  function addNav(card) {
    if (card.__lbNav) return;
    card.__lbNav = 1;
    if (list(card).length < 2) return;
    var link = card.querySelector('a.product-item__image') || figure(card);
    if (!link) return;
    card.addEventListener('mouseenter', function () { preload(card, (card.__lbIdx || 0) + 1); });
    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lb-card-nav lb-card-nav--' + dir;
      b.setAttribute('aria-label', dir === 'next' ? 'Next photo' : 'Previous photo');
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + CHEV[dir] + '"/></svg>';
      if (dir === 'prev') b.hidden = true;
      link.appendChild(b);
    });
  }

  // new cards (first load, Show More, filters): in Interior, measure them all, then swipe them all (one layout pass)
  function initAll(root) {
    var interior = getView() === 'interior', phone = interior && isPhone(), jobs = [];
    (root || document).querySelectorAll('.product-item[data-lb-imgs], .lpah-card[data-lb-imgs], .lpah-wall[data-lb-imgs]').forEach(function (card) {
      addNav(card);
      if (!card.classList.contains('product-item')) return;  // product-page rows: arrows only, no Artwork | Interior switch
      if (!interior || card.__lbView === 'interior') return;
      card.__lbView = 'interior';
      if (!phone) show(card, roomIndex(card));
      var j = phoneTarget(card, 'interior');
      if (j) jobs.push(j);
    });
    phoneGo(jobs);
  }

  function setView(v) {
    saveView(v);
    document.body.setAttribute('data-lb-card-view', v);
    document.querySelectorAll('[data-lb-card-view-btn]').forEach(function (b) {
      var on = b.getAttribute('data-lb-card-view-btn') === v;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    // phones swipe the carousels only: the desktop photo (and its downloads) is hidden there
    var phone = isPhone(), jobs = [];
    document.querySelectorAll('.product-item[data-lb-imgs]').forEach(function (card) {
      card.__lbView = v;
      if (!phone) show(card, v === 'interior' ? roomIndex(card) : 0);
      var j = phoneTarget(card, v);
      if (j) jobs.push(j);
    });
    phoneGo(jobs);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.lb-card-nav');
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      var card = b.closest('[data-lb-imgs]'), imgs = list(card), n = imgs.length;
      var dir = b.classList.contains('lb-card-nav--next') ? 1 : -1;
      var idx = ((card.__lbIdx || 0) + dir + n) % n;
      show(card, idx);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'laboo_card_photo', product_handle: card.getAttribute('data-laboo-product-handle') || '',
        photo_index: idx + 1, photo_count: n, direction: dir > 0 ? 'next' : 'previous' });
      return;
    }
    var v = e.target.closest && e.target.closest('[data-lb-card-view-btn]');
    if (v) { e.preventDefault(); setView(v.getAttribute('data-lb-card-view-btn')); return; }
    // phone bar: filter -> the existing Filter & Sort drawer; details -> Shop view (bullet points) / Gallery view
    if (e.target.closest && e.target.closest('[data-lb-mbar-filter]')) {
      e.preventDefault();
      var f = document.querySelector('.collection-heading__actions button, .collection-heading button.button--outline');
      if (f) f.click();
      return;
    }
    if (e.target.closest && e.target.closest('[data-lb-mbar-info]')) {
      e.preventDefault();
      var next = document.body.getAttribute('data-laboo-collection-view') === 'shop' ? 'gallery' : 'shop';
      var vb = document.querySelector('[data-laboo-collection-view-button="' + next + '"]');
      if (vb) vb.click();
      syncInfo();
    }
  }, true);

  // 1 Nov 2026: toolbar Sort by (computer + phone) sets the Filter & Sort drawer's sort, so the grid updates in place like a filter
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-lb-sort]');
    if (!s) return;
    var drawer = document.getElementById('mobile-SortBy');
    if (drawer && drawer.form) {
      drawer.value = s.value;
      drawer.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }
    var u = new URL(location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });

  function syncInfo() {
    var on = document.body.getAttribute('data-laboo-collection-view') === 'shop';
    document.querySelectorAll('[data-lb-mbar-info]').forEach(function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }

  // phones: the bar and the product grid run edge to edge; the theme's container offset differs per layout, so measure it
  function bleed() {
    if (!matchMedia('(max-width: 767px)').matches) return;
    [['.lb-mbar', '--lb-bleed-bar'], ['#main-collection-product-grid', '--lb-bleed-grid']].forEach(function (p) {
      var el = document.querySelector(p[0]);
      if (!el || (el.classList && el.classList.contains('is-fixed'))) return;
      var cur = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(p[1])) || 0;
      var off = el.getBoundingClientRect().left;
      if (Math.abs(off) > 0.5) document.documentElement.style.setProperty(p[1], (cur - off) + 'px');
    });
  }

  // phone bar (and, since 1 Nov, the tablet / computer toolbar .lb-tbar) sticks just under the fixed offer strip + header
  function stickTop() {
    var h = document.querySelector('main-header.site-header'), bar = null;
    document.querySelectorAll('.lb-mbar, .lb-tbar').forEach(function (b) {
      if (getComputedStyle(b).display !== 'none') { bar = bar || b; return; }
      if (b.classList.contains('is-fixed')) {  // screen turned past 768px: let go of the bar that is now hidden
        b.classList.remove('is-fixed');
        var s = b.previousElementSibling;
        if (s && s.classList.contains('lb-mbar-spacer')) { s.classList.remove('is-on'); s.style.height = '0'; }
      }
    });
    if (!h || !bar) return;
    var top = Math.max(0, Math.floor(h.getBoundingClientRect().bottom));  // floor: tuck under the header, no sub-pixel gap
    document.documentElement.style.setProperty('--lb-mbar-top', top + 'px');
    var sp = bar.previousElementSibling;
    if (!sp || !sp.classList.contains('lb-mbar-spacer')) {
      sp = document.createElement('div');
      sp.className = 'lb-mbar-spacer';
      bar.parentNode.insertBefore(sp, bar);
    }
    var fix0 = bar.classList.contains('is-fixed');
    var grid = document.querySelector('#main-collection-product-grid');
    var past = (fix0 ? sp : bar).getBoundingClientRect().top < top;
    var ended = grid && grid.getBoundingClientRect().bottom < top + 120;
    var fix = past && !ended;
    if (bar.classList.contains('lb-tbar')) {  // fixed toolbar: buttons stay lined up with the cards
      var g = bar.parentNode.getBoundingClientRect();
      document.documentElement.style.setProperty('--lb-tbar-l', Math.round(g.left) + 'px');
      document.documentElement.style.setProperty('--lb-tbar-r', Math.round(document.documentElement.clientWidth - g.right) + 'px');
    }
    if (fix !== bar.classList.contains('is-fixed')) {
      var hh = bar.offsetHeight, bcs = getComputedStyle(bar);  // size + spacing in the page, before it is fixed
      sp.style.marginTop = fix ? bcs.marginTop : '';
      sp.style.marginBottom = fix ? bcs.marginBottom : '';
      bar.classList.toggle('is-fixed', fix);
      sp.classList.toggle('is-on', fix);
      sp.style.height = fix ? hh + 'px' : '0';
    }
  }

  // phone reviews (option C): one dot per pair of reviews under the track; tap a dot to jump, dots follow the swipe (Tony 30 Oct)
  function reviewDots() {
    document.querySelectorAll('.product-bottom-reviews--carousel .laboo-prv__track').forEach(function (track) {
      if (track.__lbDots) return;
      track.__lbDots = 1;
      var dots = document.createElement('div');
      dots.className = 'lb-rv-dots';
      track.parentNode.insertBefore(dots, track.nextSibling);
      function pages() { return Math.ceil(track.querySelectorAll('.laboo-prv__card').length / 2); }
      function step() { return track.clientWidth + (parseFloat(getComputedStyle(track).columnGap) || 0); }
      function current() { return track.clientWidth ? Math.round(track.scrollLeft / step()) : 0; }
      function build() {
        var n = pages();
        if (dots.children.length !== n) {
          dots.innerHTML = '';
          for (var i = 0; i < n; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Reviews ' + (i * 2 + 1) + ' to ' + (i * 2 + 2));
            dots.appendChild(b);
          }
        }
        dots.hidden = n < 2;
        mark();
      }
      function mark() {
        var c = current();
        [].forEach.call(dots.children, function (b, i) { b.setAttribute('aria-current', i === c ? 'true' : 'false'); });
      }
      dots.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        var i = [].indexOf.call(dots.children, b);
        track.scrollTo({ left: i * step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', mark, { passive: true });
      new MutationObserver(build).observe(track, { childList: true });
      build();
    });
  }

  // language sites: English reviews in the carousels shown in the site's language, marked as translated; 'Purchased', the
  // star label and the print name in the site's language too (Tony 30 Oct). Data: laboo-review-translations.json.
  var RV_URL = ((document.currentScript && document.currentScript.src) || '').replace('laboo-card-nav.js', 'laboo-review-translations.json');
  var rvLang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase(), rvData = null, rvTitles = {};
  function rvKey(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function translateReviews() {
    if (rvLang === 'en' || RV_URL.indexOf('laboo-review-translations.json') < 0) return;
    var cards = [].slice.call(document.querySelectorAll('.laboo-prv__card:not([data-lb-tr])'));
    if (!cards.length) return;
    cards.forEach(function (c) { c.setAttribute('data-lb-tr', ''); });
    rvData = rvData || fetch(RV_URL).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    rvData.then(function (d) {
      if (!d || !d.label[rvLang]) return;
      var map = {};
      d.items.forEach(function (it) { if (it[rvLang]) map[rvKey(it.b)] = it[rvLang]; });
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      cards.forEach(function (c) {
        var body = c.querySelector('.laboo-prv__body'), title = c.querySelector('.laboo-prv__title');
        var tr = body && map[rvKey(body.textContent)];
        if (tr) {
          if (title && tr[0]) title.textContent = tr[0];
          body.textContent = tr[1];
          var note = document.createElement('p');
          note.className = 'laboo-prv__tr';
          note.textContent = d.label[rvLang];
          body.parentNode.insertBefore(note, body.nextSibling);
        }
        var st = c.querySelector('.laboo-prv__stars');
        if (st) st.setAttribute('aria-label', d.stars[rvLang]);
        var pr = c.querySelector('.laboo-prv__product');
        if (pr && pr.firstChild && pr.firstChild.nodeType === 3) pr.firstChild.nodeValue = d.purchased[rvLang] + ' ';
        var img = c.querySelector('.laboo-prv__img'), h = img && img.getAttribute('data-handle'), a = pr && pr.querySelector('a');
        if (h && a) {
          rvTitles[h] = rvTitles[h] || fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
          rvTitles[h].then(function (p) { if (p && p.title) { a.textContent = p.title; if (img) img.setAttribute('aria-label', p.title); } });
        }
      });
    });
  }

  function start() {
    var v = getView();
    document.body.setAttribute('data-lb-card-view', v);
    document.querySelectorAll('[data-lb-card-view-btn]').forEach(function (b) {
      var on = b.getAttribute('data-lb-card-view-btn') === v;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    initAll();
    if (v === 'interior') setView('interior');
    if (document.querySelector('.lb-mbar, .lb-tbar')) {
      syncInfo();
      new MutationObserver(syncInfo).observe(document.body, { attributes: true, attributeFilter: ['data-laboo-collection-view'] });
      var raf = 0;
      var tick = function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; stickTop(); }); };
      window.addEventListener('scroll', tick, { passive: true });
      window.addEventListener('resize', function () { bleed(); tick(); });
      bleed();
      stickTop();
    }
    // cards added later (load more, filters, recommendations)
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { initAll(); reviewDots(); translateReviews(); }, 120); })
      .observe(document.body, { childList: true, subtree: true });
  }
  // phone collection description: 2 lines ending "... more" right after the text; "less" closes it (Tony 30 Oct)
  function descMore() {
    if (!document.body.classList.contains('template-collection') || !matchMedia('(max-width: 767px)').matches) return;
    var box = document.querySelector('.collection-text-inner .banner-text');
    var inner = box && box.firstElementChild;
    if (!inner || box.classList.contains('lb-desc-ready')) return;
    box.classList.add('lb-desc-ready');
    var full = inner.innerHTML, text = inner.textContent.replace(/\s+/g, ' ').trim();
    var lh = parseFloat(getComputedStyle(inner).lineHeight) || 22;
    if (inner.offsetHeight <= lh * 2.5) return;  // already 2 lines or less
    var btn = function (label, open) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lb-desc-more';
      b.textContent = label;
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.addEventListener('click', function () { open ? collapse() : expand(); });
      return b;
    };
    function expand() {
      inner.innerHTML = full;
      var last = inner.lastElementChild || inner;
      last.appendChild(document.createTextNode(' '));
      last.appendChild(btn('less', true));
    }
    function collapse() {
      var words = text.split(' '), lo = 1, hi = words.length, best = 1;
      var p = document.createElement('p'), span = document.createElement('span'), b = btn('more', false);
      p.appendChild(span);
      p.appendChild(document.createTextNode(' '));
      p.appendChild(b);
      inner.innerHTML = '';
      inner.appendChild(p);
      while (lo <= hi) {  // longest start of the text that still fits on 2 lines with "... more"
        var mid = (lo + hi) >> 1;
        span.textContent = words.slice(0, mid).join(' ').replace(/[,.;:]$/, '') + '…';
        if (inner.offsetHeight <= lh * 2.5) { best = mid; lo = mid + 1; } else { hi = mid - 1; }
      }
      span.textContent = words.slice(0, best).join(' ').replace(/[,.;:]$/, '') + '…';
    }
    collapse();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); descMore(); reviewDots(); translateReviews(); });
  else { start(); descMore(); }
})();
